import React from 'react'
import { useTranslation } from 'react-i18next'
import { WizardStepProps } from 'app-view/components/Wizard/types'
import { useAdminActions } from 'pages/AdminView/hooks/useAdminActions'
import { Loader } from 'app-view/components/Spinner'
import { GreenButton, RedButton } from 'app-view/components/buttons'
import { FlexBox, Text } from 'app-view/components/Styled'
import theme from 'app-config/theme'
import { CheckingIcon, TimesIcon } from 'app-view/components/icons'
import { config } from 'app-config'

export const NoAccountInfo = ({ goTo }: WizardStepProps) => {
  const { t } = useTranslation(['account'])
  const [{ loading }, { cancelAccountRequest, retryAccountKYCRequest, approveAccountRequest }] =
    useAdminActions()

  const rejectAccount = async () => {
    const { success } = await cancelAccountRequest()
    if (success) goTo('success')
  }

  const approveAccount = async () => {
    const { success } = await approveAccountRequest(true)
    if (success) goTo('success')
  }

  const retryKYC = async () => {
    const { success } = await retryAccountKYCRequest()
    if (success) goTo('success')
  }

  if (loading) return <Loader text={t('loading_action')} />
  return (
    <>
      <Text color={theme.colors.black} style={{ marginBlock: '3rem' }}>
        No User Information
      </Text>
      <FlexBox
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        style={{ width: '100%' }}
      >
        {!config.features.kyc && (
          <GreenButton onClick={approveAccount} style={{ minWidth: '100%' }}>
            {t('p2p:approve')}
            <CheckingIcon
              style={{
                height: '21.44px',
                width: '21.44px',
                marginLeft: '8px',
              }}
              color={theme.colors.white}
            />
          </GreenButton>
        )}
        <FlexBox alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
          <RedButton onClick={rejectAccount}>
            {t('p2p:reject')}{' '}
            <TimesIcon
              style={{
                height: '14.15px',
                width: '14.15px',
                stroke: theme.colors.white,
                marginLeft: '8px',
              }}
              color={theme.colors.white}
            />
          </RedButton>
          <RedButton onClick={retryKYC} style={{ whiteSpace: 'nowrap', minWidth: 'max-content' }}>
            {'Send Retry KYC '}
            <TimesIcon
              style={{
                height: '14.15px',
                width: '14.15px',
                stroke: theme.colors.white,
                marginLeft: '8px',
              }}
              color={theme.colors.white}
            />
          </RedButton>
        </FlexBox>
      </FlexBox>
    </>
  )
}
